// src/components/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';

const PrivateRoute = ({ children, roles = [], requiredRole }) => {
  const {
    // admin
    user,
    loading,
    isAuthenticated,
    // teacher
    teacherUser,
    teacherLoading,
    isTeacherAuthenticated
  } = useContext(AuthContext);

  const location = useLocation();

  // === 1) Flow professeur ===
  if (requiredRole === 'teacher') {
    if (teacherLoading) {
      return <div>Loading…</div>;
    }
    if (!isTeacherAuthenticated || !teacherUser) {
      return (
        <Navigate
          to="/teacher-login"
          state={{ from: location }}
          replace
        />
      );
    }
    return children;
  }

  // === 2) Flow admin ===
  if (loading) {
    return <div>Loading…</div>;
  }
  if (!isAuthenticated || !user) {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }
  if (roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default PrivateRoute;
